// Rasterizes a ThumbnailBuilder SVG data URL to a PNG File (2x scale, after
// web fonts load) so generated thumbnails can be uploaded like any image.
export const svgDataUrlToPngFile = (dataUrl, filename) => {
  return new Promise((resolve, reject) => {
    if (
      typeof dataUrl !== "string" ||
      !dataUrl.startsWith("data:image/svg+xml")
    ) {
      reject(new Error("Invalid SVG data URL."));
      return;
    }

    const img = new Image();
    img.onload = async () => {
      if (document.fonts?.ready) {
        await document.fonts.ready;
        await Promise.all([
          document.fonts.load('300 19px "Open Sans"'),
          document.fonts.load('400 19px "Open Sans"'),
        ]);
      }

      const width = img.naturalWidth || img.width || 160;
      const height = img.naturalHeight || img.height || 160;
      const rasterScale = 2;

      const canvas = document.createElement("canvas");
      canvas.width = width * rasterScale;
      canvas.height = height * rasterScale;

      const context = canvas.getContext("2d");
      if (!context) {
        reject(new Error("Unable to render thumbnail."));
        return;
      }

      context.imageSmoothingEnabled = true;
      context.imageSmoothingQuality = "high";
      context.drawImage(img, 0, 0, canvas.width, canvas.height);

      canvas.toBlob(
        (blob) => {
          if (!blob) {
            reject(new Error("Failed to encode thumbnail as PNG."));
            return;
          }

          resolve(new File([blob], filename, { type: "image/png" }));
        },
        "image/png",
        1,
      );
    };

    img.onerror = () => {
      reject(new Error("Failed to load generated SVG."));
    };

    img.src = dataUrl;
  });
};
